import React, { useEffect, useState } from 'react';
import { LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer, AreaChart, Area } from 'recharts';
import axios from 'axios';
import { BASE_URL, USER_URL } from '../../constant/api';
import { Link } from 'react-router-dom';

function SellerSales() {

  const [topProduct, setTopProduct] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [revenueData, setRevenueData] = useState([]);
  const [totalRevenue, setTotalRevenue] = useState(0);
  const [satisfactionData, setSatisfactionData] = useState([]);
  

 
  
  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      const headers = { Authorization: `Token ${token}` };

      try {
        const [
          topResponse,
          catResponse,
        ] = await Promise.all([
          USER_URL.get(`/products/seller/top-selling/`,),
          USER_URL.get(`/categories/`,),
        ]);

        setTopProduct(topResponse.data.Data || []);
        setCategories(catResponse.data.Data || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);
  console.log(topProduct);
  
  const getCategoryName = (id) => {
    return categories.find((cat) => cat.id === id)?.name || 'Unknown Category';
  };

  // Map category names during data preparation
const topData = topProduct.map((product) => ({
  id: product.id, // Add unique product ID for rendering
  title: product.name,
  category: getCategoryName(product.category), // Get the category name
  imageSrc: product.product_images[0]?.image || '', // Use product image or fallback
}));

  
useEffect(() => {
  const fetchRevenueData = async () => {
    const token = localStorage.getItem('token');
    const headers = { Authorization: `Token ${token}` };

    try {
      const response = await USER_URL.get(
        `/orders/seller/monthly-revenue/?year=${selectedYear}`,
        // { headers }
      );
      const data = response.data.Data || [];
      setRevenueData(data);
    

      // Calculate total revenue
      const total = data.reduce((sum, item) => sum + (item.revenue || 0), 0);
      setTotalRevenue(total);
    } catch (error) {
      console.error('Error fetching revenue data:', error);
      setRevenueData([]);
      setTotalRevenue(0);
    }
  };

  fetchRevenueData();
}, [selectedYear]);

useEffect(() => {
  const fetchSatisfactionData = async () => {
    const token = localStorage.getItem('token');
    // const headers = { Authorization: `Token ${token}` };

    try {
      const response = await USER_URL.get(
        `/orders/seller/satisfaction/?year=${selectedYear}`,
        // { headers }
      );
      const data = response.data.Data || [];
      setSatisfactionData(data);
      console.log(response);
    } catch (error) {
      console.error('Error fetching satisfaction data:', error);
      setSatisfactionData([]); // Ensure it always defaults to an empty array
    }
  };

  fetchSatisfactionData();
}, [selectedYear]);



const CustomDot = (props) => {
  const { cx, cy, fill } = props;

  return (
    <circle
      cx={cx}
      cy={cy}
      r={6} // Set the radius
      fill={fill || "#00BFFF"} // Default fill color to a vibrant blue
      style={{
        filter: 'drop-shadow(0 0 4px rgba(0, 123, 255, 0.5))', // Glow effect
        cursor: 'pointer',
      }}
    />
  );
};





  return (
    <div>
     
      <div className="flex justify-center  min-h-screen ">
        <h1 className='text-2xl font-medium text-green-600 '></h1>
        <div className="flex flex-col lg:flex-row gap-8 w-full max-w-7xl mt-10 mb-16">
          <div className="flex flex-col gap-6 lg:w-2/3">
            {/* Total Revenue Chart */}
            <div className="border bg-white p-3 rounded-xl shadow-md">
              <div className="flex justify-between items-center mb-4">
                <div>
                  <h2 className="text-3xl font-bold text-gray-900">
                  ₹{totalRevenue.toLocaleString()}
                  </h2>
                  <p className="text-sm text-orange-500 font-semibold">
                    Total Revenue
                  </p>
                </div>
                <select
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(parseInt(e.target.value))}
                  className="px-3 py-1 bg-gray-100 rounded-lg border border-gray-300 text-gray-600"
                >
                  {[2022, 2023, 2024, 2025].map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
              <ResponsiveContainer width="100%" height={250}>
                <LineChart
                  data={revenueData}
                  margin={{ top: 10, right: 30, left: 10, bottom: 10 }}
                >
                  <CartesianGrid strokeDasharray="3 3" vertical={false} />
                  <XAxis
                    dataKey="month"
                    tickFormatter={(month) => month.slice(0, 3)}
                    tick={{ fontSize: 12 }}
                    interval={0}
                  />
                  <YAxis
                    tickFormatter={(value) => ` ₹${value.toLocaleString()}`}
                    domain={[0, 'auto']}
                  />
                  <Tooltip formatter={(value) => ` ₹${value.toLocaleString()}`} />
                  <Line
                    type="monotone"
                    dataKey="revenue"
                    stroke="#00c853"
                    strokeWidth={3}
                    dot={false}
                    
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>

            {/* Customer Satisfaction Chart */}
            <div className="border bg-white p-5 rounded-xl shadow-md mt-5">
  <div className="flex justify-between items-center mb-4">
  <h2 className="text-lg font-semibold text-gray-800">Customer Satisfaction</h2>
        <select
          value={selectedYear}
          onChange={(e) => setSelectedYear(parseInt(e.target.value))}
          className="px-3 py-1 bg-gray-100 rounded-lg border border-gray-300 text-gray-600"
        >
          {[2022, 2023, 2024, 2025].map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>
      <ResponsiveContainer width="100%" height={250}>
  <AreaChart data={satisfactionData}>
    <defs>
      <linearGradient id="colorRating" x1="0" y1="0" x2="0" y2="1">
        <stop offset="5%" stopColor="#1E90FF" stopOpacity={0.5} />
        <stop offset="95%" stopColor="#1E90FF" stopOpacity={0} />
      </linearGradient>
    </defs>
    <CartesianGrid strokeDasharray="3 3" opacity={0.1} />
    <XAxis
      dataKey="month"
      tickFormatter={(month) => month.slice(0, 3)}
      tick={{ fontSize: 12 }}
      interval={0}
      padding={{ left: 10, right: 10 }}
    />
    <YAxis
      domain={[1, 5]} // Explicitly set range to 1-5
      ticks={[1, 2, 3, 4, 5]} // Ensure Y-axis shows 1, 2, 3, 4, 5
      tick={{ fontSize: 12 }}
    />
    <Tooltip />
    <Area
      type="monotone"
      dataKey="average_rating"
      fill="url(#colorRating)"
      stroke="#1E90FF"
      strokeWidth={3}
      fillOpacity={1}
      dot={<CustomDot fill="#1E90FF" />} 
    />
  </AreaChart>
</ResponsiveContainer>


</div>

          </div>

          {/* Top Selling Products Section */}
          <div className="lg:w-1/3 order-last lg:order-last">
  {/* <button className="bg-green-500 text-sm text-white font-semibold w-40 ml-36 py-3 rounded-lg">
    Sales View
  </button> */}

  <h2 className="text-xl font-semibold text-gray-800 ">Top Selling Products</h2>

  {topData.length > 0 ? (
    topData.map((product) => (
      <div key={product.id} className="flex items-center flex-col p-4 mt-10 bg-gray-50 rounded-xl shadow ">
        <img
          src={product.imageSrc} // Use the mapped product image source
          alt={product.title}
          className="size-52 rounded-lg "
        />
        <div className="mt-1">
          <h3 className="text-md font-semibold text-gray-700">{product.title}</h3>
          <div className="flex items-center justify-between">
            {/* Display the category name and "View" button on the same line */}
            <p className="text-sm text-gray-500">Category: {product.category}</p>
            <Link to={`/seller/products/view/${product.id}`} className="ml-9 w-12 px-2 py-1 text-xs font-medium text-gray-600 bg-gray-200 rounded-full hover:bg-gray-300">
              View
            </Link>
          </div>
        </div>
      </div>
    ))
  ) : (
    <p className="text-gray-500 mt-10">No top-selling products found.</p>
  )}
</div>


        </div>
      </div>
    </div>
  );
}

export default SellerSales;